class MainProductCustom {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-variant-id-input]')?.closest('form');
    this.variantInput = root.querySelector('[data-variant-id-input]');
    this.variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    this.selectedOptions = [];

    this.initGallery();
    this.initOptions();
    this.initQuantity();
    this.initAccordions();
    this.initStickyCart();
    this.initBundle();
    this.initAjaxCart();
    this.initMiniCart();
  }

  initGallery() {
    const thumbnails = this.root.querySelectorAll('[data-thumbnail]');
    const mediaItems = this.root.querySelectorAll('[data-main-media]');

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.mediaId;

        thumbnails.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');

        mediaItems.forEach((item) => {
          item.classList.toggle('is-active', item.dataset.mediaId === mediaId);
        });
      });
    });
  }

  initOptions() {
    const optionGroups = this.root.querySelectorAll('[data-option-index]');
    if (optionGroups.length === 0) return;

    optionGroups.forEach((group) => {
      const index = parseInt(group.dataset.optionIndex, 10);
      const selected = group.querySelector('.is-selected');
      this.selectedOptions[index] = selected ? selected.dataset.value : null;
    });

    this.root.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = parseInt(button.dataset.optionIndex, 10);
        const value = button.dataset.value;

        const group = button.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('is-selected'));
        button.classList.add('is-selected');
        const label = group.querySelector('[data-option-value-label]');
        if (label) label.textContent = value;

        this.selectedOptions[index] = value;
        this.updateVariant();
      });
    });
  }

  updateVariant() {
    if (!this.variants.length) return;

    const match = this.variants.find((variant) =>
      variant.options.every((option, i) => option === this.selectedOptions[i])
    );

    const addToCartButton = this.root.querySelector('[data-add-to-cart]');
    const addToCartText = this.root.querySelector('[data-add-to-cart-text]');
    const priceCurrent = this.root.querySelector('[data-price-current]');
    const priceCompare = this.root.querySelector('[data-price-compare]');
    const priceBadge = this.root.querySelector('[data-price-badge]');
    const skuEl = this.root.querySelector('[data-sku]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyButton = document.querySelector('[data-sticky-add-to-cart]');

    if (!match) {
      if (addToCartButton) addToCartButton.disabled = true;
      if (addToCartText) addToCartText.textContent = 'Unavailable';
      return;
    }

    if (this.variantInput) this.variantInput.value = match.id;

    const moneyFormat = (window.mainProductCustomMoneyFormat && window.mainProductCustomMoneyFormat[match.id]) || {};

    if (priceCurrent) priceCurrent.textContent = moneyFormat.price || this.formatMoney(match.price);
    if (stickyPrice) stickyPrice.textContent = moneyFormat.price || this.formatMoney(match.price);

    if (match.compare_at_price && match.compare_at_price > match.price) {
      if (priceCompare) {
        priceCompare.textContent = moneyFormat.compareAtPrice || this.formatMoney(match.compare_at_price);
        priceCompare.style.display = '';
      }
      if (priceBadge) {
        const percent = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
        priceBadge.textContent = `Save ${percent}%`;
        priceBadge.style.display = '';
      }
    } else {
      if (priceCompare) priceCompare.style.display = 'none';
      if (priceBadge) priceBadge.style.display = 'none';
    }

    if (skuEl) skuEl.textContent = `SKU: ${match.sku || ''}`;

    const available = match.available;
    if (addToCartButton) addToCartButton.disabled = !available;
    if (addToCartText) addToCartText.textContent = available ? 'Add to cart' : 'Sold out';
    if (stickyButton) stickyButton.disabled = !available;

    if (match.featured_media && match.featured_media.id) {
      const mediaId = String(match.featured_media.id);
      const thumbnail = this.root.querySelector(`[data-thumbnail][data-media-id="${mediaId}"]`);
      if (thumbnail) thumbnail.click();
    }

    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: this.currencyCode() });
  }

  currencyCode() {
    return this.root.dataset.currencyCode || 'USD';
  }

  initQuantity() {
    const input = this.root.querySelector('[data-quantity-input]');
    const decrease = this.root.querySelector('[data-quantity-decrease]');
    const increase = this.root.querySelector('[data-quantity-increase]');
    if (!input) return;

    decrease?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });

    increase?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  }

  initAccordions() {
    this.root.querySelectorAll('[data-accordion]').forEach((accordion) => {
      const trigger = accordion.querySelector('[data-accordion-trigger]');
      const panel = accordion.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = accordion.getAttribute('data-open') === 'true';
        accordion.setAttribute('data-open', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  initStickyCart() {
    const stickyBar = document.querySelector('[data-sticky-cart]');
    const addToCartButton = this.root.querySelector('[data-add-to-cart]');
    if (!stickyBar || !addToCartButton) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.hidden = false;
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(addToCartButton);
  }

  initBundle() {
    const bundle = this.root.querySelector('[data-bundle]');
    if (!bundle) return;

    this.bundle = bundle;
    const checkboxes = bundle.querySelectorAll('[data-bundle-checkbox]');
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.updateBundleTotal());
    });

    const addButton = bundle.querySelector('[data-bundle-add]');
    addButton?.addEventListener('click', () => this.addBundleToCart());

    this.updateBundleTotal();
  }

  updateBundleTotal() {
    if (!this.bundle) return;

    const mainPrice = parseInt(this.bundle.dataset.mainPrice, 10) || 0;
    let total = mainPrice;

    this.bundle.querySelectorAll('[data-bundle-item][data-price]').forEach((item) => {
      const checkbox = item.querySelector('[data-bundle-checkbox]');
      if (checkbox && checkbox.checked) {
        total += parseInt(item.dataset.price, 10) || 0;
      }
    });

    const totalEl = this.bundle.querySelector('[data-bundle-total]');
    if (totalEl) totalEl.textContent = this.formatMoney(total);
  }

  addBundleToCart() {
    if (!this.bundle || !this.variantInput) return;

    const addButton = this.bundle.querySelector('[data-bundle-add]');
    const errorEl = this.bundle.querySelector('[data-bundle-error]');
    const quantityInput = this.root.querySelector('[data-quantity-input]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    const items = [{ id: parseInt(this.variantInput.value, 10), quantity }];

    this.bundle.querySelectorAll('[data-bundle-item][data-variant-id]').forEach((item) => {
      const checkbox = item.querySelector('[data-bundle-checkbox]');
      if (checkbox && checkbox.checked) {
        items.push({ id: parseInt(item.dataset.variantId, 10), quantity: 1 });
      }
    });

    if (errorEl) errorEl.hidden = true;
    if (addButton) addButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add bundle to cart');
        this.openMiniCart();
      })
      .catch((error) => {
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      })
      .finally(() => {
        if (addButton) addButton.disabled = false;
      });
  }

  initAjaxCart() {
    if (!this.form) return;

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitAddToCart(new FormData(this.form));
    });
  }

  submitAddToCart(formData) {
    const addToCartButton = this.root.querySelector('[data-add-to-cart]');
    const stickyButton = document.querySelector('[data-sticky-add-to-cart]');
    const errorEl = this.root.querySelector('[data-cart-error]');

    if (errorEl) errorEl.hidden = true;
    if (addToCartButton) addToCartButton.disabled = true;
    if (stickyButton) stickyButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add item to cart');
        this.openMiniCart();
      })
      .catch((error) => {
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      })
      .finally(() => {
        const available = this.currentVariantAvailable();
        if (addToCartButton) addToCartButton.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
      });
  }

  currentVariantAvailable() {
    if (!this.variants.length || !this.variantInput) return true;
    const variant = this.variants.find((v) => String(v.id) === String(this.variantInput.value));
    return variant ? variant.available : true;
  }

  initMiniCart() {
    this.miniCart = document.querySelector('[data-mini-cart]');
    if (!this.miniCart) return;

    const overlay = this.miniCart.querySelector('[data-mini-cart-overlay]');
    const closeButton = this.miniCart.querySelector('[data-mini-cart-close]');

    overlay?.addEventListener('click', () => this.closeMiniCart());
    closeButton?.addEventListener('click', () => this.closeMiniCart());
  }

  openMiniCart() {
    if (!this.miniCart) return;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        this.renderMiniCart(cart);
        this.miniCart.hidden = false;
      });
  }

  closeMiniCart() {
    if (this.miniCart) this.miniCart.hidden = true;
  }

  renderMiniCart(cart) {
    const itemsEl = this.miniCart.querySelector('[data-mini-cart-items]');
    const subtotalEl = this.miniCart.querySelector('[data-mini-cart-subtotal]');
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="main-product-custom-cart__empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items
        .map((item) => `
          <div class="main-product-custom-cart__item">
            <img src="${item.image || ''}" alt="" width="64" height="64">
            <div class="main-product-custom-cart__item-info">
              <span class="main-product-custom-cart__item-title">${item.product_title}</span>
              ${item.variant_title ? `<span class="main-product-custom-cart__item-variant">${item.variant_title}</span>` : ''}
              <span class="main-product-custom-cart__item-qty">Qty ${item.quantity} · ${this.formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        `)
        .join('');
    }

    if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);
  }
}

document.querySelectorAll('[data-product-custom]').forEach((root) => {
  new MainProductCustom(root);
});
